/**
 * @deprecated
 */
export enum StatusType {
  info = 'gray',
  warning = 'yellow',
  danger = 'red',
  success = 'green',
}
/**
 * @deprecated
 */
export enum StatusColors {
  gray = 'bg-gray-300',
  yellow = 'bg-yellow-300',
  red = 'bg-red-600',
  green = 'bg-green-600',
}
